// extracted by mini-css-extract-plugin
module.exports = {"rateOption":"hP","rateIcon":"hQ","rateLabel":"hR","inPlayer":"hS","rateIconWrapper":"hT","inPlayerRateModal":"hU"};